export default __webpack_public_path__ + "static/media/151-religious.ed20f0f6.png";